import axios from "axios";

export default {
  state: () => ({
    data: [],
    loadingData: false,
    errorLoadingData: false,
  }),
  mutations: {
    fetchedData(state, apps) {
      state.data = apps || [];
      if (apps !== null) {
        state.errorLoadingApps = false;
      }
    },
    loadingData(state, loadingFlag) {
      state.loadingData = loadingFlag || false;
    },
    errorLoadingData(state, errorFlag) {
      state.errorLoadingData = errorFlag || false;
    },
  },
  getters: {
    data: (state) => state.data,
    loadingData: (state) => state.loadingData,
    errorLoadingData: (state) => state.errorLoadingData,
  },
  actions: {
    getApps({ commit }) {
      const url = "/apis/app-catalog-api/apps";
      commit("loadingData", true);

      return axios
        .get(url)
        .then((response) => {
          commit("loadingData", false);
          if (response.status !== 200) {
            commit("fetchedData", null);
            commit("errorLoadingData", true);
            return;
          }
          commit("fetchedData", response.data);
        })
        .catch(() => {
          commit("loadingData", false);
          commit("fetchedData", null);
          commit("errorLoadingData", true);
        });
    },
  },
};
